export const DISTRIBUTION_RULE_API = (communityId: any) => `v1/community/${communityId}/distribution-rules`
export const DISTRIBUTION_METRICS_API = (communityId: any) => `v1/community/${communityId}/distribution-metrics`
export const DISTRIBUTION_JOBS_API = (communityId: string) => `v1/distribution-jobs/community/${communityId}`
export const GL_ASSIGNMENT_API = (communityId: string) => `v1/gl-distribution-assignments/community/${communityId}`
export const GL_API = `v1/gl-masters`
export const HIERARCHY_API = `v1/communities`
export const DISTRIBUTION_REPORT_API = `v1/community`